<template>
  <div class="home">
    <div class="fixfoner" v-if="usedata.isUpdatePass">
      <div class="forcontaine">
        <h3>修改密码</h3>
        <md-field v-if="updataType===1">
          <md-input-item
            title="當前密碼"
            v-model="user.oldPassword"
            placeholder="請輸入當前密碼"
          />
          <md-input-item
            title="新密碼"
            v-model="user.password"
            placeholder="請輸入新密碼"
          />
          <md-input-item
            title="確認新密碼"
            v-model="user.agginpas"
            placeholder="請再次輸入當前密碼"
            no-border/>
        </md-field>
        <md-field v-if="updataType===2">
          <md-input-item
            title="邮箱"
            v-model="user.email"
            placeholder="請輸入當前邮箱"
          />
        </md-field>
        <p style="font-size: 0.26rem;color: red; text-align: left;width:90%;margin-left:5%" v-if="updataType===1">
          密码至少8位数字，英文，符号组合而成，本系统要求每年修改一次密码</p>
        <p
          style="font-size: 0.26rem;color: #333333; text-align: left;width:90%;margin-left:5%;padding-top: 0.2rem;margin-bottom: 0.2rem"
          v-if="usedata.validate&&updataType===1">{{ usedata.validate }}</p>
        <div style="display: flex;" v-if="updataType===1">
          <md-button :loading="loading" type="primary" @click="updataType=2">忘记密码</md-button>
          <md-button :loading="loading" type="warning" @click="submitpas">提交</md-button>
        </div>
        <div style="display: flex;" v-if="updataType===2">
          <md-button :loading="loading" type="primary" @click="updataType=1">修改密码</md-button>
          <md-button :loading="loading" type="warning" @click="submitemail">提交</md-button>
        </div>

      </div>
    </div>
    <div class="bangdintaobe" v-if="userInfotao.shopCode==='2240932806'">
      <p style="font-size: 0.2rem;font-weight: bolder;">绑定淘宝账号 <span v-if="userInfotao.taobaoOpenUserId"
                                                                           style="margin-left: 0.1rem;color: orangered">已绑定</span>
      </p>
      <span style="color: #333333">淘宝订单免预报</span>
      <div class="quabngenr" @click="gobangdin()" v-if="!userInfotao.taobaoOpenUserId">
        <span>去绑定</span>
      </div>
    </div>
    <div class="homeTop">
      <md-drop-menu :data="data" :default-value="defaultvalue" @change="selectCountry"/>
      <md-tag size="large" shape="bubble"
              fill-color="linear-gradient(180deg, #FF5B60 0%, #F98472 100%)" type="fill" class="message"
              v-if="num > 0">{{ num }}
      </md-tag>
      <img src="@/assets/image/long.png" alt="" class="messageimg" @click="viewClick(4)"/>
    </div>
    <div :style="scrollheight">
      <div style="width: 100%; height: 0.9rem; position: relative"></div>
      <div
        style="width: 100%;height: 2.5rem;background-color: #e32c1a;border-bottom-left-radius: 0.15rem;border-bottom-right-radius: 0.15rem"></div>
      <div class="listView">
        <!-- biubiulink店铺展示 其他店铺不展示轮播图11 -->
        <md-swiper ref="swiper" :is-prevent="false" :useNative-driver="false"
                   v-if="shopkey.appCode === '1572677768'">
          <md-swiper-item :key="$index" v-for="(item, $index) in simple">
            <div class="banner-item" @click="bannerClick(item)">
              <img :src="item.img" alt=""/>
            </div>
          </md-swiper-item>
        </md-swiper>
        <div class="menu">
          <div v-for="(item, index) in meuList" :key="index" @click="menuClick(index)"
               :class="index < 4 ? 'menuItem' : 'meninen'"
               :style="{ width: item.isShow === true ? '25%' : '0% !important' }">
            <div class="flex_col_center" v-if="item.isShow">
              <img :src="item.img" alt=""/>
              <div class="menuTitle lefthal">
                <p>{{ item.name }}</p>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 100%; height: 0.1rem; position: relative"></div>
        <div class="menu">
          <div class="fourTitle">
            <span style="font-weight: 600">簡單3步，完成集運之旅</span>
            <!-- <span
              style="font-size: 0.26rem; color: #2a78dc"
              @click="menuClick(4)"
              >查看教程</span
            > -->
          </div>
          <div style="display: flex; align-items: center">
            <div v-for="(item, index) in stpList" :key="index" class="menufourserve">
              <img src="@/assets/image/arrowline.png" alt="" v-if="index != 2" class="linimg"/>
              <img :src="item.imgUrl" alt=""/>
              <div class="menuTitle">
                <p>{{ item.title }}</p>
                <span>{{ item.detaile }}</span>
                <div class="munbtn" @click="viewClick(index + 5)">
                  <span>{{ item.btn }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tuijiantie">
          <div class="letjfcje">
            <div :class="packeind == 0 ? 'activeur ujujwj' : 'ujujwj'" @click="packeind = 0">
              <span>国内包裹{{ packnumber }}</span>
            </div>
            <div :class="packeind == 1 ? 'activeur ujujwj' : 'ujujwj'" @click="packeind = 1">
              <span>国际包裹{{ ordernumber }}</span>
            </div>
          </div>
          <div class="rigewn" @click="menuClick(1)">
            <span>+添加包裹</span>
          </div>
        </div>
        <div class="linshcne">
          <div v-if="packeind == 0">
            <div class="lineList" v-for="(item, index) in packlist" :key="index"
                 @click="godetail(item)">
              <div class="lineTitle">
                <span v-if="item.status < 11">待入庫</span>
                <span v-if="item.status == 11">待補資料</span>
                <span v-if="item.status == 12">待合包</span>
                <span v-if="item.status == 13">超期</span>
                <span v-if="item.status == 14">待補資料</span>
                <span v-if="item.status == 21">[拒收]尺寸超标</span>
                <span v-if="item.status == 22">[拒收]包裹超重</span>
                <span v-if="item.status == 23">[拒收]违禁物品</span>
                <span v-if="item.status == 24">[拒收]涉嫌侵权</span>
                <span v-if="item.status == 31">已合包</span>
                <span v-if="item.status == 32">已销毁</span>
                <span v-if="item.status == 33">退货中</span>
                <span v-if="item.status == 34">退货完成</span>
              </div>
              <div class="linexpri">
                <span
                  v-if="item.expressCompany">{{ item.expressCompany }}-{{ item.expressNumber }}</span>
                <span v-else>{{ item.expressNumber }}</span>
              </div>
              <div class="linjdjje">
                <span v-if="item.status >= 11" class="packweight">{{ item.weight }}KG</span>
                <span v-for="its in item.list" :key="its.id">
                  {{ its.name }}*{{ its.num }}
                </span>
              </div>
            </div>
            <div v-if="packlist.length < 1" class="zjhwjje">
              <span>暫無數據</span>
            </div>
          </div>
          <div v-if="packeind == 1">
            <div class="lineList" v-for="(item, index) in orderlist" :key="index"
                 @click="goorderdetail(item)">
              <div class="btenmr">
                <span v-if="item.status == 1">待付款</span>
                <span v-if="item.status == 2">待收貨</span>
                <span v-if="item.status == 4">已取消</span>
                <span v-if="item.status == 5">退款中</span>
              </div>
              <div class="ordejrjr">
                <span> 訂單號：{{ item.code }} </span>
              </div>
              <div class="ordejseer">
                <span>{{ item.countryName }}-{{ item.transCode }}</span>
                <span style="margin-left: 0.4rem">{{ item.weight }}KG</span>
              </div>
              <div class="linjdjje" v-if="item.trackDetail">
                <span>{{ item.trackDetail.eventscan }}</span>
              </div>
            </div>
            <div v-if="orderlist.length < 1" class="zjhwjje">
              <span>暫無數據</span>
            </div>
          </div>
          <div class="lineekdk" @click="viewClick(7)" v-if="packeind == 0 && packlist.length > 0">
            <span>查看全部包裹
              <md-icon name="arrow-right"/>
            </span>
          </div>
          <div class="lineekdk" @click="viewClick(8)" v-if="packeind == 1 && orderlist.length > 0">
            <span>查看全部訂單
              <md-icon name="arrow-right"/>
            </span>
          </div>
        </div>
      </div>
      <div style="width: 100%; height: 2.8rem"></div>
    </div>
    <!-- 首次进入未选择国家弹出窗 -->
    <md-selector v-model="isSelectorShow" :data="countruylist" title="請選擇您要集運的目的地"
                 min-height="100px" large-radius :mask-closable="false" class="cheklist"
                 @choose="onSelectorConfirm" is-check></md-selector>

    <md-popup class="inner-popup" v-model="showPic" position="center">
      <md-popup-title-bar large-radius title="您已获得新人券" @cancel="hidePopUp('align')">
      </md-popup-title-bar>
      <div class="md-example-popup md-example-popup-align">
        <md-scroll-view :scrolling-x="false">
          <div class="coupliste">

            <div class="coupitem" v-for="(item,index) in copuuserlist" :key="index">
              <div class="couypright">
                <span class="name">{{ item.name }}</span>
                <span
                  class="rule">有效期：{{
                    item.beginTime| dateformat('YYYY-MM-DD')
                  }}-{{ item.endTime| dateformat('YYYY-MM-DD') }}</span>
              </div>
              <div class="couypleft">
                <span class="price" v-if="item.type!=2">￥{{ item.price }}</span>
                <span class="price" v-if="item.type==2">{{ item.price }}折</span>
              </div>

            </div>
          </div>
          <div class="bottomsunner" @click="cleinjnr()">
            <span>欣然收下</span>
          </div>
          <span style="font-size:0.3rem;margin-top: -0.2rem;">可在下单时抵扣</span>
        </md-scroll-view>
      </div>
    </md-popup>
    <!-- 活动海报 -->
    <md-landscape v-model="showWxKefu" @hide="showWxKefu = false" :mask-closable="true">
      <img :src="shopkey.wxQrCodeUrl" style="width: 70%;"/>
    </md-landscape>
    <!-- APP链接 -->
    <!-- <div class="downloadapp" @click="downapp" v-if="!shopkey.appCode">
      <div class="icon">
        <img src="@/assets/image/logo.png" alt="" />
      </div>
      <span>biubiulinkAPP</span>
    </div> -->
    <!-- 在线客服 -->
    <md-popup v-model="kefuPopuoShow" position="bottom">
      <md-popup-title-bar title="联系客服" describe="" large-radius @cancel="kefuPopuoShow = false">
      </md-popup-title-bar>
      <div class="kefu-popup-bottom">
        <div class="kefu" @click="selectKefu('QQ')" v-if="!isBlank(userInfo.qqServiceLink)">
          <img src="@/assets/image/kefu/qq.png" alt=""/>
          <p>QQ客服</p>
        </div>
        <div class="kefu" @click="selectKefu('WW')" v-if="!isBlank(userInfo.taobaoServiceLink)">
          <img src="@/assets/image/kefu/ww.png" alt=""/>
          <p>旺旺客服</p>
        </div>
        <div class="kefu" @click="selectKefu('WX')" v-if="!isBlank(shopkey.wxQrCodeUrl)">
          <img src="@/assets/image/kefu/wx.png" alt=""/>
          <p>微信客服</p>
        </div>
        <div class="kefu" @click="selectKefu('LINE')" v-if="linuke.length>0">
          <img src="@/assets/image/logo_line.png" alt=""/>
          <p>line客服</p>
        </div>
      </div>
    </md-popup>
    <!-- 微信客服 -->
    <md-popup v-model="showPicactive" :mask-closable="false">
      <div style="width: 90%;display: flex;justify-content: flex-end">
        <div style="width: 1rem;height: 1rem;color: white;font-size: 0.8rem;font-weight: 500"
             @click="showPicactive=false">x
        </div>
      </div>
      <img :src="activedata.picUrl" style="width: 70%" @click="goactive"/>
      <p style="color: orangered;font-size: 16px" @click="hideactive" v-if="activedata.activityType===2">不在提示</p>
    </md-popup>
    <!--    <md-landscape v-model="showPicactive" @hide="hideactive">-->
    <!--      <img :src="activedata.picUrl" style="width: 70%" @click="goactive" />-->
    <!--    </md-landscape>-->
    <!-- 弹出公告 -->
    <md-landscape v-model="showCustomTransition" transition="md-bounce" :mask-closable="false"
                  @click="showListen=true" @hide="hiddenetc()">
      <div class="eJectModal">
        <div class="title">
          {{ EjectData.title }}
        </div>
        <div class="content" v-html="EjectData.content"></div>
        <div class="footer">
          <md-check name="notice" v-model="agreeConf" label="不再提醒"/>
          <md-button type="default" size="small" inline plain @click="closeEjectModal"
                     style="margin-left: 0.2rem">确定
          </md-button>
        </div>
      </div>
    </md-landscape>
  </div>
</template>
<script>
import {getUrlKey} from '../../until/getUrlcode';
import {
  DropMenu,
  Tag,
  Icon,
  Button,
  Toast,
  Selector,
  Swiper,
  SwiperItem,
  ScrollView,
  ScrollViewRefresh,
  Amount,
  Landscape,
  Check,
  Popup,
  PopupTitleBar,
  Field, FieldItem, InputItem,
} from 'mand-mobile';
import simple from 'mand-mobile/components/swiper/demo/data/simple';
import {isBlank} from '../../until/common';
import md5 from "js-md5";

export default {
  name: 'home',
  components: {
    [DropMenu.name]: DropMenu,
    [Selector.name]: Selector,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Landscape.name]: Landscape,
    [Icon.name]: Icon,
    [Amount.name]: Amount,
    [Swiper.name]: Swiper,
    [ScrollView.name]: ScrollView,
    [ScrollViewRefresh.name]: ScrollViewRefresh,
    [SwiperItem.name]: SwiperItem,
    [Check.name]: Check,
    [Popup.name]: Popup,
    [PopupTitleBar.name]: PopupTitleBar,
    [Field.name]: Field,
    [Button.name]: Button,
    [FieldItem.name]: FieldItem,
    [InputItem.name]: InputItem
  },
  data() {
    return {
      countryallid: '',
      couponIn: {},
      linuke: [],
      userInfotao: {
        taobaoOpenUserId: null,
        shopCode: '123'
      },
      usedata: {
        isUpdatePass: false,
        validate: null,
        email: null
      },
      updataType: 1,
      user: {
        oldPassword: '',
        password: '',
        agginpas: ''
      },
      packnumber: 0,
      packeind: 0,
      ordernumber: 0,
      copuuserlist: [],
      showPic: false,
      showPicactive: false,
      scrollheight: {
        height: document.documentElement.clientHeight + 'px',
      },
      simple: [{img: require('@/assets/image/beand21_375.png')}],
      isSelectorShow: false,
      defaultvalue: [], // 默认选中国家
      countruylist: [],
      activedata: {},
      num: null,
      packlist: [],
      orderlist: [],
      stpList: [
        {
          imgUrl: require('@/assets/image/icon_init_01.png'),
          title: '轉運準備',
          detaile: '複製倉庫地址到電商平臺',
          btn: '複製地址',
        },
        {
          imgUrl: require('@/assets/image/icon_init_03.png'),
          title: '添加包裹',
          detaile: '添加快遞單號和報關資訊',
          btn: '添加',
        },
        {
          imgUrl: require('@/assets/image/icon_init_04.png'),
          title: '發往海外',
          detaile: '選擇多個包裹寄送，節省運費',
          btn: '發貨 ',
        },
      ],
      meuList: [
        {
          name: '倉庫地址',
          englisgName: 'Transhipment',
          img: require('@/assets/image/1.png'),
          isShow: true,
        },
        {
          name: '添加包裹',
          englisgName: 'Common Problem',
          img: require('@/assets/image/2.png'),
          isShow: true,
        },
        {
          name: '充值中心',
          englisgName: 'Freight Trial',
          img: require('@/assets/image/3.png'),
          isShow: true,
        },
        {
          name: '聯系客服',
          englisgName: 'Service & Price',
          img: require('@/assets/image/4.png'),
          isShow: true,
        },
        {
          name: '新手指南',
          englisgName: "Beginner's Guide",
          img: require('@/assets/image/licon1.png'),
          isShow: true,
        },
        {
          name: '常見問題',
          englisgName: 'Customer Service',
          img: require('@/assets/image/licon2.png'),
          isShow: true,
        },
        {
          name: '運費試算',
          englisgName: 'Customer Service',
          img: require('@/assets/image/licon3.png'),
          isShow: true,
        },
        {
          name: '服務&價格',
          englisgName: 'Customer Service',
          img: require('@/assets/image/licon4.png'),
          isShow: true,
        },
      ],
      data: [
        {
          text: '請選擇集運網站',
          options: [],
        },
        {
          disabled: true,
        },
        {
          disabled: true,
        },
      ],
      // 弹出公告
      showCustomTransition: false,
      EjectData: {},
      agreeConf: false,
      // 绑定店铺资料
      shopkey: {},
      // 用户资料
      userInfo: {},
      // 在线客服
      kefuPopuoShow: false,
      showWxKefu: false,
      loading: false,
    };
  },
  mounted() {
    // 首页初始化
    this.appContext();
    // console.log("Home")

    // 推广码链接
    // localStorage.removeItem('activeid');
    if (getUrlKey('rqCode', window.location.href)) {
      localStorage.setItem('rqCode', getUrlKey('rqCode', window.location.href));
      this.promotion();
    } else {
      localStorage.removeItem('rqCode');
    }

    // 未登录
    if (
      !localStorage.getItem('mupressMobiltoken') &&
      localStorage.getItem('mupressMobiltoken') != undefined
    ) {
      console.log('isLogin False');
      this.$router.replace({
        name: 'Login',
        query: {
          parentCode: getUrlKey('parentCode', window.location.href),
        },
      });
      return false;
    }
  },
  activated() {
    this.getIsdayta()
    // 页面是否绑定店铺配置
    this.isBindShopDate();

    if (
      localStorage.getItem('mupressMobiltoken') &&
      localStorage.getItem('mupressMobiltoken') != undefined
    ) {
      // 已登陆
      this.getUserInfo(); // 更新用户资料
      this.getCountry(null); // 更新城市列表
      this.getMessageCount(); // 用户消息数
      this.parcelindexList(); // 用户包裹列表
      if (JSON.parse(localStorage.getItem('userinfoMobie')).payType == 0) {
        // payType 用户支付级别，0 新用户（刚注册，需要展示功能介绍和领取优惠券），1 非新客（已领取优惠券），2 已支付过订单
      }
      // 每次进入更新用户国家/地区
      if (
        localStorage.getItem('userinfoMobie') &&
        localStorage.getItem('mupressMobiltoken') != undefined
      ) {
        // console.log("更新用户资料, 用户选中国家/地区");
        this.userInfo = JSON.parse(localStorage.getItem('userinfoMobie'));
        this.countryallid = JSON.parse(
          localStorage.getItem('userinfoMobie')
        ).disVo.id;
        this.defaultvalue[0] = JSON.parse(
          localStorage.getItem('userinfoMobie')
        ).disVo.id;
        this.data[0].text = JSON.parse(
          localStorage.getItem('userinfoMobie')
        ).disVo.name;
        this.initEjectNotice(this.defaultvalue[0]);
        this.getkie(this.defaultvalue[0]);
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (
      localStorage.getItem('mupressMobiltoken') &&
      localStorage.getItem('userinfoMobie')
    ) {
      next();
    } else {
      if (to.name == 'Package' || to.name == 'Order') {
        var index = 7;
        to.name == 'Package' ? (index = 7) : (index = 8);
        this.$router.push({
          name: 'Login',
          query: {
            id: this.defaultvalue[0],
            index: index,
            pagename: this.data[0].text,
            packindecx: '0',
          },
        });
      } else if (to.name == 'My') {
        this.$router.replace({
          name: 'Login',
        });
        // localStorage.setItem("firconteid", this.defaultvalue[0]);
        // localStorage.setItem("fircontename", this.data[0].text);
      } else {
        next();
      }
    }
  },
  methods: {
    isBlank,
    isBindShopDate() {
      if (localStorage.getItem('shopkey')) {
        this.shopkey = JSON.parse(localStorage.getItem('shopkey'));
        this.meuList = this.meuList.filter(function (item, index) {
          if (item.name === '新手指南') {
            item.isShow = false;
          }
          return item;
        });

        // 如果缓存用户信息绑定的店铺与当前地址获取的店铺不一致 则清除登录信息 重新登录
        if (
          localStorage.getItem('userinfoMobie') &&
          this.shopkey.appCode !==
          JSON.parse(localStorage.getItem('userinfoMobie')).shopCode
        ) {
          console.log('账号绑定店铺与当前店铺不一致');
          localStorage.removeItem('userinfoMobie');
          localStorage.removeItem('mupressMobiltoken');
          localStorage.removeItem('headerParams');
          location.reload();
        }
      }
    },
    getIsdayta() {
      this.http.APIASK(this.ports.getIsdayta, 'POST').then((res) => {
        this.usedata = res
      })

    },
    submitemail() {
      if (!this.user.email) {
        Toast.failed('請輸入邮箱')
        return
      }
      this.loading = true;
      const par = {
        account: this.user.email.trim(),
        appCode: this.shopkey.appCode
      };
      this.http
        .APIASK(this.ports.sendPasswordMail, "post", par)
        .then(res => {
          Toast.succeed('重制密碼的郵件已發送到', +this.user.email)
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    submitpas() {
      console.log(this.user)
      if (!this.user.oldPassword) {
        Toast.failed('請輸入當前密碼')
        return
      }
      if (!this.isNumberOr_Letter(this.user.password)) {
        Toast.failed('密码至少8位数字，英文，符号组合而成')
        return
      }
      if (!this.user.agginpas) {
        Toast.failed('請再次輸入當前密碼')
        return
      }
      if (this.user.agginpas != this.user.password) {
        Toast.failed('兩次密碼不一致')
        return
      }
      if (this.user.password === this.user.oldPassword) {
        Toast.failed('新密碼和當前密碼一致')
        return
      }
      // 111
      const param = JSON.parse(JSON.stringify(this.user));
      param.oldPassword = md5(param.oldPassword)
      param.password = md5(param.password)
      param.agginpas = md5(param.agginpas)
      this.loading = true
      this.http.APIASK(this.ports.updatePassword, 'post', param).then(res => {
        this.loading = false
        Toast.succeed('修改成功')
        this.getIsdayta()
      }).catch(err => {
        this.loading = false
      });
    },
    isNumberOr_Letter(s) {
      var reg1 = /^(?=.*[0-9])(?=.*[A-Za-z])(?=.*[^A-Za-z0-9]).{8,}$/;
      if (reg1.test(s)) {
        return true
      } else {
        return false
      }
    },
    gobangdin() {
      let appcode = JSON.parse(localStorage.getItem('userinfoMobie')).accountCode
      console.log(appcode)
      window.location.href = 'https://world.taobao.com/wow/tmg-fc/tmw/account-bind?disableNav=YES&bindCode=' + appcode + '&appkey=33881287'
    },
    hideactive() {
      localStorage.setItem('activeid', this.activedata.id);
      this.showPicactive = false
    },
    getkie(countryId) {
      const par = {
        countryId,
      };
      this.http.APIASK(this.ports.getLineService, 'get', par).then((res) => {
        this.linuke = res;
      });
    },
    // 获取弹出公告
    initEjectNotice(countryId) {
      const par = {
        countryId: countryId,
        appcode: this.shopkey.appCode,
      };
      this.agreeConf = false;
      this.http.APIASK(this.ports.getEjectNotice, 'get', par).then((res) => {
        if (res !== null && res.id) {
          this.EjectData = res;
          const list = localStorage.getItem('EjectNotice_off')
            ? JSON.parse(localStorage.getItem('EjectNotice_off'))
            : [];
          if (!list.includes(this.EjectData.id)) {
            this.showCustomTransition = true;
          }
        } else {
          this.getcuoer();
        }
      });
    },
    hiddenetc() {
      console.log(123);
      this.getcuoer();
    },
    getcuoer() {
      if (localStorage.getItem('couplist')) {
        this.copuuserlist = JSON.parse(localStorage.getItem('couplist'));
        this.showPic = true;
      }
    },
    // 关闭弹出公告
    closeEjectModal() {
      this.showCustomTransition = false;

      if (this.agreeConf) {
        let array = localStorage.getItem('EjectNotice_off')
          ? JSON.parse(localStorage.getItem('EjectNotice_off'))
          : [];
        array.push(this.EjectData.id);
        localStorage.setItem('EjectNotice_off', JSON.stringify(array));
      }
    },
    cleinjnr() {
      this.showPic = false;
      localStorage.removeItem('couplist');
    },
    getMessageCount() {
      this.http
        .APIASK(this.ports.getMessageCount, 'get')
        .then((res) => {
          this.getActive();
          res.num > 0 ? (this.num = res.num) : (this.num = null);
        })
        .catch((err) => {
        });
    },
    promotion() {
      const par = {
        promotionCode: localStorage.getItem('rqCode'),
      };
      this.http.APIASK(this.ports.promotion, 'get', par).then((res) => {
      });
    },
    getActive() {
      this.http
        .APIASK(this.ports.getActive, 'get')
        .then((res) => {
          if (res) {
            if (res.id) {
              if (localStorage.getItem('activeid')) {
                if (localStorage.getItem('activeid') != res.id) {
                  this.showPicactive = true;
                }
              } else {
                this.showPicactive = true;
              }
            }
            this.activedata = res;
          } else {
            this.showPicactive = false;
          }
        })
        .catch((err) => {
        });
    },
    parcelindexList() {
      const par = {
        pageSize: 5,
        pageNum: 0,
      };
      this.http
        .APIASK(this.ports.parcelindexList, 'get', par)
        .then((res) => {
          this.packlist = res.list;
          this.packnumber = res.total;
        })
        .catch((err) => {
        });
      this.http.APIASK(this.ports.orderindexList, 'get', par).then((res) => {
        this.orderlist = res.list;
        this.ordernumber = res.total;
      });
    },
    // 活动海报
    goactive() {
      if (localStorage.getItem('mupressMobiltoken')) {
        window.location.href =
          this.activedata.linkUrl +
          '&cnm=' +
          localStorage.getItem('mupressMobiltoken') + '&shopcode=' + this.shopkey.appCode;
      } else {
        this.$router.push({
          name: 'Login',
          query: {
            id: this.defaultvalue[0],
            index: 3,
            pagename: this.data[0].text,
          },
        });
        // localStorage.setItem('firconteid', this.defaultvalue[0]);
        // localStorage.setItem('fircontename', this.data[0].text);
        // window.location.href = this.activedata.linkUrl;
      }
    },
    newcomer() {
      this.http
        .APIASK(this.ports.newcomer, 'post')
        .then((res) => {
          this.showPic = false;
          this.getUserInfo();
        })
        .catch((err) => {
          this.showPic = false;
          this.getUserInfo();
        });
    },
    // 下载APP
    downapp() {
      window.location.href = 'https://www.huyuntong.com';
    },
    getUserInfo() {
      this.http
        .APIASK(this.ports.getUserInfo, 'get')
        .then((res) => {
          this.userInfotao = res
          localStorage.setItem('userinfoMobie', JSON.stringify(res));
        })
        .catch((err) => {
        });
    },
    // 更新用户绑定国家
    updateUserCountry(id) {
      const par = {
        countryId: id,
      };
      this.http
        .APIASK(this.ports.updateUserCountry, 'post', par)
        .then((res) => {
          this.getUserInfo();
        })
        .catch((err) => {
          this.getUserInfo();
        });
    },
    // 获取新人优惠券信息
    couponInfo() {
      this.http.APIASK(this.ports.couponInfo, 'post').then((res) => {
        if (res) {
          this.couponIn = res;
          this.couponIn.allprice = res.price * res.num;
        }
        res.id ? (this.showPic = true) : (this.showPic = false);
      });
    },
    appContext() {
      this.http.APIASK(this.ports.appContext, 'post').then((res) => {
        localStorage.setItem('appUrl', JSON.stringify(res));
        if (
          localStorage.getItem('mupressMobiltoken') &&
          localStorage.getItem('userinfoMobie')
        ) {
          this.countryallid = JSON.parse(
            localStorage.getItem('userinfoMobie')
          ).disVo.id;
          this.defaultvalue[0] = JSON.parse(
            localStorage.getItem('userinfoMobie')
          ).disVo.id;
          this.data[0].text = JSON.parse(
            localStorage.getItem('userinfoMobie')
          ).disVo.name;
          this.getCountry(this.defaultvalue[0]);
          this.getBanner(this.defaultvalue[0]);
        } else if (localStorage.getItem('firstvalue')) {
          this.countryallid = localStorage.getItem('firstvalue');
          this.defaultvalue[0] = localStorage.getItem('firstvalue');
          this.data[0].text = localStorage.getItem('firstnam');
          this.getCountry(this.defaultvalue[0]);
          this.getBanner(this.defaultvalue[0]);
        }
      });
    },
    menuClick(index) {
      switch (parseInt(index)) {
        case 4:
          // 新手指南
          window.location.href = JSON.parse(
            localStorage.getItem('appUrl')
          ).appGuidebook;
          break;
        case 1:
          if (localStorage.getItem('mupressMobiltoken')) {
            this.$router.push({
              name: 'Predition',
              query: {id: this.defaultvalue[0]},
            });
          } else {
            this.$router.push({
              name: 'Login',
              query: {
                id: this.defaultvalue[0],
                index: index,
                pagename: this.data[0].text,
              },
            });
          }
          break;
        case 2:
          if (localStorage.getItem('mupressMobiltoken')) {
            this.$router.push({
              name: 'Chongzhi',
              query: {id: this.defaultvalue[0]},
            });
          } else {
            this.$router.push({
              name: 'Login',
              query: {
                id: this.defaultvalue[0],
                index: index,
                pagename: this.data[0].text,
              },
            });
          }
          break;
        case 3:
          // 在线客服
          if (localStorage.getItem('mupressMobiltoken')) {
            // 进入用户绑定的店铺的QQ客服链接页面
            this.kefuPopuoShow = true;
            //   var v = this.countruylist.find((value, index, arr) => {
            //     return value.value == this.defaultvalue[0];
            //   });
            //   window.location.href = "https://ysftest4.qiyukf.com/client?k=2ae0e7640493795d063e35538c69a050&templateId=4474201&wp=1&sid=" + v.customerServiceId;
          } else {
            this.$router.push({
              name: 'Login',
              query: {
                id: this.defaultvalue[0],
                index: index,
                pagename: this.data[0].text,
              },
            });
          }
          break;
        case 0:
          if (localStorage.getItem('mupressMobiltoken')) {
            this.$router.push({
              name: 'Address',
              query: {id: this.defaultvalue[0]},
            });
          } else {
            this.$router.push({
              name: 'Login',
              query: {
                id: this.defaultvalue[0],
                index: index,
                pagename: this.data[0].text,
              },
            });
          }
          break;
        case 5:
          this.$router.push({
            name: 'Problem',
            query: {id: this.defaultvalue[0]},
          });
          break;
        case 6:
          this.$router.push({
            name: 'Try',
            query: {
              id: this.defaultvalue[0],
              list: JSON.stringify(this.countruylist),
            },
          });
          break;
        case 7:
          this.$router.push({
            name: 'Server',
            query: {id: this.defaultvalue[0]},
          });
          break;
      }
    },
    viewClick(index) {
      switch (parseInt(index)) {
        case 0:
          this.$router.push({
            name: 'Address',
            query: {id: this.defaultvalue[0]},
          });
          break;
        case 1:
          this.$router.push({
            name: 'Predition',
            query: {id: this.defaultvalue[0]},
          });
          break;
        case 2:
          this.$router.push({
            name: 'Chongzhi',
            query: {id: this.defaultvalue[0]},
          });
          break;
        case 3:
          var v = this.countruylist.find((value, index, arr) => {
            return value.value == this.defaultvalue[0];
          });
          window.location.href =
            'https://ysftest4.qiyukf.com/client?k=2ae0e7640493795d063e35538c69a050&templateId=4474201&wp=1&sid=' +
            v.customerServiceId;
          break;
        case 4:
          this.$router.push({
            name: 'Message',
            query: {id: this.defaultvalue[0]},
          });
          break;
        case 5:
          this.$router.push({
            name: 'Address',
            query: {id: this.defaultvalue[0]},
          });
          break;
        case 6:
          this.$router.push({
            name: 'Predition',
            query: {id: this.defaultvalue[0]},
          });
          break;
        case 7:
          this.$router.push({
            name: 'Package',
            query: {id: this.defaultvalue[0], packindecx: '1'},
          });
          break;
        case 8:
          this.$router.push({
            name: 'Order',
            query: {id: this.defaultvalue[0]},
          });
          break;
      }
    },
    selectKefu(type) {
      let qqServiceLink = this.userInfo.qqServiceLink;
      let taobaoServiceLink = this.userInfo.taobaoServiceLink;
      let wxQrCodeUrl = this.shopkey.wxQrCodeUrl;
      switch (type) {
        case 'QQ':
          var url =
            'mqq://im/chat?chat_type=wpa&uin=' +
            qqServiceLink +
            '&version=1&src_type=web';
          // PC端： http://wpa.qq.com/msgrd?v=3&uin=1756688303&site=qq&menu=yes
          // 移动端：mqq://im/chat?chat_type=wpa&uin=1756688303&version=1&src_type=web
          window.location.href = url;
          break;
        case 'WW':
          window.location.href = taobaoServiceLink;
          break;
        case 'WX':
          console.log(wxQrCodeUrl);
          this.showWxKefu = true;
          break;
        case 'LINE':
          window.location.href = this.linuke[0].lineUrl;
          break;
      }
      this.kefuPopuoShow = false;
    },
    getBanner(id) {
      const par = {
        countryId: id || '',
      };
      this.http
        .APIASK(this.ports.banner, 'get', par)
        .then((res) => {
          this.simple = res;
          Toast.hide();
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    // 缓存城市列表
    getCountry(id) {
      const par = {
        parentId: 0,
      };
      this.http
        .APIASK(this.ports.country, 'get', par)
        .then((res) => {
          localStorage.setItem('countryList', JSON.stringify(res));
          const data = res.map(function (item) {
            return {
              text: item.name,
              value: item.id,
            };
          });
          Toast.hide();
          this.data[0].options = data;
          this.countruylist = data;
          if (
            localStorage.getItem('mupressMobiltoken') &&
            localStorage.getItem('userinfoMobie')
          ) {
            this.countryallid = JSON.parse(
              localStorage.getItem('userinfoMobie')
            ).disVo.id;
            this.defaultvalue[0] = JSON.parse(
              localStorage.getItem('userinfoMobie')
            ).disVo.id;
            this.data[0].text = JSON.parse(
              localStorage.getItem('userinfoMobie')
            ).disVo.name;
          } else if (localStorage.getItem('firstnam')) {
            this.countryallid = localStorage.getItem('firstvalue');
            this.defaultvalue[0] = localStorage.getItem('firstvalue');
            this.data[0].text = localStorage.getItem('firstnam');
          } else {
            id ? null : (this.isSelectorShow = true);
          }
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    // 首次进入选择国家/地区
    async onSelectorConfirm({value, text}) {
      Toast.loading('加載中...');
      localStorage.setItem('firstnam', text);
      localStorage.setItem('firstvalue', value);
      this.countryallid = value;
      this.defaultvalue[0] = value;
      this.data[0].text = text;
      // this.isBindShopDate(); // 获取shopKey
      this.getCountry(this.defaultvalue[0]);
      this.getBanner(this.defaultvalue[0]);
      this.initEjectNotice(this.defaultvalue[0]);
      this.getkie(this.defaultvalue[0]);
    },
    // 顶部选择国家回调
    selectCountry(barItem, listItem) {
      this.data[0].text = listItem.text;
      localStorage.setItem('firstnam', listItem.text);
      localStorage.setItem('firstvalue', listItem.value);
      if (this.countryallid != listItem.value) {
        this.countryallid = listItem.value;
        this.getBanner(listItem.value);
        localStorage.getItem('mupressMobiltoken') &&
        localStorage.getItem('userinfoMobie')
          ? this.updateUserCountry(listItem.value)
          : null;
      }
      this.initEjectNotice(listItem.value);
      this.getkie(listItem.value);
    },
    // 轮播图点击事件
    bannerClick(item) {
      if (item.type == '1') {
        if (item.url.indexOf('?id') == -1 || item.url.indexOf('&id') == -1) {
          if (localStorage.getItem('mupressMobiltoken')) {
            window.location.href =
              item.url + '&cnm=' + localStorage.getItem('mupressMobiltoken') + '&shopcode=' + this.shopkey.appCode;
          } else {
            this.$router.push({
              name: 'Login',
              query: {
                id: this.defaultvalue[0],
                index: 3,
                pagename: this.data[0].text,
              },
            });
          }
        }
      } else if (item.type == '0') {
        window.location.href =
          '/res/appservice/m/article/index.html?id=' +
          item.articleId +
          '&type=1';
      } else if (item.type == '4') {
        if (item.webRouteAddr) {
          window.location.href = item.webRouteAddr;
        }
      }
    },
    godetail(item) {
      if (item.status >= 11) {
        this.$router.push({
          name: 'Packdetail',
          query: {id: item.id, status: item.status},
        });
      }
    },
    goorderdetail(item) {
      this.$router.push({name: 'OrderDetail', query: {id: item.id}});
    },
  },
};
</script>
<style>
.md-landscape .md-icon.md-landscape-close {
  display: block;
}
</style>
<style lang="less">
.downloadapp {
  width: 2.5rem;
  height: 0.8rem;
  position: fixed;
  right: 0;
  top: 26%;
  border-bottom-left-radius: 0.5rem;
  border-top-left-radius: 0.5rem;
  background-color: rgba(86, 176, 254, 0.9);
  z-index: 99999;
  display: flex;
  align-items: center;

  span {
    font-size: 0.22rem;
    color: white;
    margin-left: 0.08rem;
  }

  .icon {
    height: 100%;
    border-radius: 0.5rem;
    overflow: hidden;
    display: flex;
    align-items: center;

    img {
      height: 70%;
      border-radius: 50%;
      margin-left: 0.2rem;
    }
  }
}

.homeTop {
  width: 100%;
  height: 1rem;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;

  .md-drop-menu {
    z-index: 10;
  }

  .md-drop-menu-bar {
    background-color: #e32c1a;
    color: #ffffff;

    span:after {
      display: none;
    }

    .bar-item.selected {
      color: #ffffff;
    }
  }

  .md-drop-menu-bar :first-child span:after {
    display: block;
    border-left: 0.08rem solid transparent;
    border-right: 0.08rem solid transparent;
    border-top: 0.09rem solid #ffffff;
  }

  .md-drop-menu-bar .bar-item.active {
    color: #ffffff;
  }

  .message {
    position: absolute;
    top: 0.15rem;
    z-index: 999;
    right: 0.04rem;
  }

  .messageimg {
    position: absolute;
    top: 0.25rem;
    z-index: 999;
    right: 0.39rem;
    width: 0.55rem;
    height: auto;
  }
}

.cheklist {
  .md-cell-item-title {
    text-align: left;
  }
}

.banner-item {
  width: 94%;
  height: 3.5rem;
  margin-left: 3%;

  img {
    width: 100%;
    height: auto;
    border-radius: 0.1rem;
  }
}

.listView {
  width: 100%;
  margin-top: -2.3rem;

  .menu {
    position: relative;
    background-color: white;
    display: flex;
    width: 94%;
    margin-left: 3%;
    flex-wrap: wrap;
    box-shadow: 2px 2px 7px 2px rgba(207, 207, 207, 0.5);

    .menuItem {
      height: 2rem;
      width: 25%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 0.2rem;

      img {
        width: 1rem;
        height: auto;
        margin: 0.2rem 0;
      }

      .menuTitle {
        display: flex;
        height: 60%;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;

        p {
          font-size: 0.33rem;
          font-weight: 500;
        }

        span {
          font-size: 0.26rem;
          color: rgba(153, 153, 153, 1);
        }
      }

      .lefthal {
        align-items: flex-start;
      }
    }

    .meninen {
      height: 1.6rem;
      width: 25%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 0.2rem;

      img {
        width: 0.7rem;
        height: auto;
        margin: 0.2rem 0;
      }

      .menuTitle {
        display: flex;
        height: 30%;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;

        p {
          font-size: 0.28rem;
          color: rgb(117, 117, 117);
        }
      }
    }

    .menuServeItems {
      width: 25%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      img {
        width: 0.9rem;
        height: auto;
        margin-top: 0.2rem;
      }

      p {
        font-size: 0.29rem;
        margin-bottom: 0.2rem;
        margin-top: 0.2rem;
        font-weight: 400;
      }
    }

    .meuminLine {
      position: absolute;
      width: 1px;
      height: 100%;
      top: 0;
      left: 49.9%;
      background-color: rgba(240, 240, 242, 1);
    }

    .meumdeLine {
      position: absolute;
      width: 100%;
      height: 1px;
      top: 33%;
      background-color: rgba(240, 240, 242, 1);
    }

    .meumdeLintwoe {
      position: absolute;
      width: 100%;
      height: 1px;
      top: 66%;
      background-color: rgba(240, 240, 242, 1);
    }

    .fourTitle {
      width: 100%;
      height: 0.8rem;
      display: flex;
      align-items: center;
      justify-content: space-between;

      span {
        padding: 0 0.2rem;
        font-size: 0.32rem;
      }
    }

    .menufourserve {
      width: 33.3%;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;

      .linimg {
        position: absolute;
        left: 2rem;
        width: 0.9rem;
        top: 0.5rem;
        height: auto;
      }

      img {
        width: 1.2rem;
        height: auto;
      }

      .menuTitle {
        width: 80%;
        height: 2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0.3rem 0;

        span {
          font-size: 0.24rem;
        }

        .munbtn {
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #f84d3c;
          color: white;
          height: 0.68rem;
          width: 1.5rem;
          border-radius: 0.4rem;
          margin-top: 0.2rem;

          span {
            font-size: 0.3rem !important;
          }
        }

        p {
          font-size: 0.31rem;
          font-weight: 500;
          margin-bottom: 0.1rem;
        }
      }
    }
  }

  .tuijiantie {
    width: 94%;
    margin-left: 3%;
    height: 1rem;
    margin-top: 0.2rem;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.3rem;

    .letjfcje {
      display: flex;
      align-items: center;
      margin-left: 0.2rem;

      .ujujwj {
        width: 2rem;
        height: 0.6rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .activeur {
        border-radius: 0.4rem;
        background-color: rgb(232, 238, 246);
        color: #e32c1a;
      }
    }

    .rigewn {
      width: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 0.6rem;
      background-color: rgb(232, 238, 246);
      color: #e64340;
      border-top-left-radius: 0.4rem;
      border-bottom-left-radius: 0.4rem;
    }
  }

  .linshcne {
    width: 94%;
    margin-left: 3%;
    background-color: white;
    padding-bottom: 0.3rem;
  }

  .lineList {
    width: 94%;
    margin-left: 3%;
    border-radius: 0.2rem;
    background-color: rgba(232, 238, 246, 1);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-bottom: 0.2rem;

    .ordejrjr {
      width: 80%;
      display: flex;
      align-items: center;
      font-size: 0.28rem;
      margin: 0.2rem 0 0.2rem 0.4rem;
    }

    .btenmr {
      position: absolute;
      right: 5%;
      margin-top: 0.2rem;
      font-size: 0.3rem;
      font-weight: 600;
    }

    .ordejseer {
      width: 80%;
      display: flex;
      align-items: center;
      font-size: 0.28rem;
      margin: 0 0 0.2rem 0.4rem;
    }

    .lineTitle {
      width: 80%;
      display: flex;
      align-items: center;
      font-size: 0.3rem;
      font-weight: 600;
      margin: 0.2rem 0 0.2rem 0.4rem;
    }

    .linexpri {
      width: 80%;
      display: flex;
      align-items: center;
      font-size: 0.28rem;
      margin: 0 0 0.2rem 0.4rem;
    }

    .linjdjje {
      width: 90%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      font-size: 0.28rem;
      margin: 0 0 0.2rem 0.4rem;
      color: rgb(153, 153, 153);

      .packweight {
        color: #101010;
        margin-right: 0.4rem;
      }
    }
  }

  .lineekdk {
    height: 0.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.28rem;
    color: #2a78dc;
  }

  .zjhwjje {
    height: 0.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.28rem;
  }
}

.md-landscape-content {
  width: 7.4rem;
}

.coubninfo {
  position: absolute;
  width: 100%;
  height: 52%;
  top: 30%;
  left: 0;

  .price {
    height: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    font-weight: 600;
    color: rgba(249, 233, 138, 1);
  }

  .anniu {
    margin-top: 0.15rem;
    width: 66%;
    height: 18%;
    margin-left: 17%;
    background-image: linear-gradient(to bottom, #f8e8ad, #f6d083);
    color: #bb291d;
  }
}

.eJectModal {
  margin: 0 auto;
  width: 21.88em;
  background: white;
  border-radius: 0.25em;
  padding: 0.2rem;
  color: #5a5a5a;
  text-align: left;

  .title {
    color: #000000;
    margin-bottom: 1em;
  }

  .content {
    max-height: 30.13em;
    overflow-y: scroll;
    margin-top: 0.2rem;
  }

  .footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
}

.kefu-popup-bottom {
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;

  .kefu {
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0.4rem;

    img {
      width: 0.7rem;
      height: auto;
      margin: 0.2rem 0;
    }
  }
}

.flex_col_center {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.coupliste {
  width: 6.6rem;
  max-height: 6rem;
  overflow-y: scroll;
}

.coupitem {
  width: 96%;
  margin-left: 2%;
  margin-top: 0.2rem;
  display: flex;
  border-radius: 0.1rem;
  align-items: center;
  background-color: white;
  position: relative;
  border: 1px solid #f2f2ff;

  .banner {
    position: absolute;
    font-size: 0.2rem;
    bottom: 0.1rem;
    left: 0.5rem;
  }

  .couypleft {
    padding: 0.2rem 0;
    display: flex;
    padding-left: 0.4rem;
    flex-direction: column;
    font-size: 0.3rem;
    align-items: flex-start;

    .price {
      font-size: 0.45rem;
      color: #f97004;
      margin-bottom: 0.2rem;
    }

    .rule {
      color: #cccccc;
    }
  }

  .couypright {
    padding: 0.2rem 0;
    display: flex;
    padding-left: 0.2rem;
    flex-direction: column;
    font-size: 0.28rem;
    align-items: flex-start;
    margin-top: 0.2rem;

    .name {
      font-size: 0.4rem;
      margin-bottom: 0.2rem;
      font-weight: bolder;
    }

    .rule {
      color: #cccccc;
    }

    .krkkrt {
      padding: 0.08rem 0.12rem;
      background-color: #2a78dc;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      margin-top: 0.2rem;
      border-radius: 0.08rem;
    }
  }
}

.bottomsunner {
  width: 60%;
  height: 1rem;
  background-color: #2a78dc;
  margin: 0.2rem 20% -0.3rem 20%;
  border-radius: 0.16rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 0.3rem;
}

.bangdintaobe {
  width: 94%;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: fixed;
  bottom: 1.5rem;
  z-index: 99;
  left: 3%;
  font-size: 0.2rem;
  background-color: white;
  border-radius: 0.1rem;
  border: 3px solid #c8c9cc;

  .quabngenr {
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    background-color: #2a78dc;
    border-radius: 0.3rem;
    padding: 0.1rem 0.2rem;
    font-weight: bolder;
  }
}

.fixfoner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1210;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .forcontaine {
    width: 90%;
    background-color: #ffffff;
    border-radius: 0.2rem;

    h3 {
      text-align: left;
      padding: 0.4rem;
      font-size: 0.4rem;
      padding-bottom: 0;
    }
  }
}
</style>
